'use client';

import {
  copyMorfiLogoPngAsset,
  copyMorfiLogoSvgAsset,
} from '@/components/logo/copy-morfi-vortex-logo';
import { AnimatedButton } from '@/components/ui/animated-button';

export function BrandKitLogoActions({
  assetUrl,
  downloadName,
}: {
  assetUrl: string;
  downloadName: string;
}): React.ReactNode {
  function handleCopySvg(): void {
    void copyMorfiLogoSvgAsset(assetUrl, 'Logo SVG copied', 'Could not copy logo SVG');
  }

  function handleCopyPng(): void {
    void copyMorfiLogoPngAsset(assetUrl, 'Logo PNG copied', 'Could not copy logo PNG');
  }

  function handleDownloadSvg(): void {
    const link = document.createElement('a');
    link.href = assetUrl;
    link.download = downloadName;
    link.click();
  }

  return (
    <div className="flex flex-wrap gap-2">
      <AnimatedButton variant="outline" size="xs" onClick={handleCopySvg}>
        Copy SVG
      </AnimatedButton>
      <AnimatedButton variant="outline" size="xs" onClick={handleCopyPng}>
        Copy PNG
      </AnimatedButton>
      <AnimatedButton variant="outline" size="xs" onClick={handleDownloadSvg}>
        Download SVG
      </AnimatedButton>
    </div>
  );
}
